<template>
	<div
		:class="['panel', 'research_about',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.theme? block.theme : ''
		]"
		:style="block.background_image.src ?
			'background-image:url(' + block.background_image.src + ')' : ''"
	>
		<div class="container">
			<div class="row align-items-center mb-0">
				<div class="col-12 col-lg-6">
					<div
						v-if="isHeaderVisible"
						:class="[
							'panel_header',
							isBrand? 'sk' : '',
						]"
					>
						<h2>
							{{ block.block_title }}
						</h2>
					</div>
					<div class="description" v-html="block.description" />
				</div>
				<div class="col-12 col-lg-5 offset-lg-1">
					<div class="overview mb-0">
						<div class="title mb-3">
							{{ block.second_title }}
						</div>

						<a
							v-if="block.embed_url"
							class="btn btn-primary-outer rounded-pill"
							:href="block.embed_url"
							target="_blank"
						>
							{{ block.embed_button }}
						</a>
						<button
							v-else
							class="btn btn-primary-outer rounded-pill"
							@click="showModal(block.embed_code);"
						>
							{{ block.embed_button }}
						</button>
					</div>
				</div>
				<b-modal id="bv-modal-video" hide-footer>
					<div class="d-block text-center">
						<b-embed
							v-if="modalVideoSrc"
							:src="modalVideoSrc + '?rel=0&enablejsapi=1'"
							type="iframe"
							allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
							frameborder="0"
							allowfullscreen
						/>
					</div>
				</b-modal>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'ResearchAbout',
	mixins: [panel],
	data() {
		return {
			modalVideoSrc: null,
		};
	},
	methods: {
		showModal(src) {
			this.$bvModal.show('bv-modal-video');
			this.modalVideoSrc = src;
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/research-chart";
</style>
